import * as React from 'react'

const SvgDragHorizontalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 2.5v6.875H3.644l1.612-1.619-.881-.881L1.25 10l3.125 3.125.881-.881-1.612-1.619H7.5V17.5h1.25v-15H7.5zm8.125 4.375l-.881.881 1.612 1.619H12.5V2.5h-1.25v15h1.25v-6.875h3.856l-1.612 1.619.881.881L18.75 10l-3.125-3.125z"
      fill="#163250"
    />
  </svg>
)

export default SvgDragHorizontalIcon
